var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"stats-card",class:("bg-" + _vm.color + "-stats")},[_c('div',{staticClass:"stats-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"stats-content"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }